module.exports = __webpack_public_path__ + "img/ourwork_bg.23918342.svg";